module.exports = __webpack_public_path__ + "img/logo.dcb3ab7c.png";